import { fetchVisitorIP } from "./ipServices.js";

// The banner reads "2026-2027 Admissions / Now open in <State>" once
// geolocation resolves. ipinfo already returns the full state name (e.g.
// "Florida"), which is also what the hidden form state field expects.
//
// Each half is its own .banner-line so the two rows are the intended split
// rather than wherever the text happens to run out of room.
function renderGeoMessage(element, state) {
  // Only the second row carries the state; the first is static.
  const tail = element.querySelectorAll(".banner-line")[1];
  if (tail) tail.textContent = `Now open in ${state}`;
}

export async function prepareForm() {
  const ipinfo = await fetchVisitorIP();

  if (ipinfo) {
    // cta message
    const fallCtaElements = document.querySelectorAll(".geo-message");
    if (fallCtaElements.length > 0) {
      fallCtaElements.forEach((element) => {
        if (ipinfo.region) {
          renderGeoMessage(element, ipinfo.region);
        }
      });
    }

    // form elements - look for both applicant and enrollment prefixed fields
    const applicant_ip = document.getElementById("applicant_ip");
    const enrollment_ip = document.getElementById("enrollment_ip");
    const ipField = applicant_ip || enrollment_ip;

    const applicant_state = document.getElementById("applicant_state");
    const enrollment_state = document.getElementById("enrollment_state");
    const stateField = applicant_state || enrollment_state;

    const applicant_country = document.getElementById("applicant_country");
    const enrollment_country = document.getElementById("enrollment_country");
    const countryField = applicant_country || enrollment_country;

    if (ipField && ipinfo.ip) ipField.value = ipinfo.ip;
    if (stateField && ipinfo.region) stateField.value = ipinfo.region;
    if (countryField && ipinfo.country) countryField.value = ipinfo.country;
  }
}
